import { useEffect } from 'react';
import { func, array, bool, object, oneOfType } from 'prop-types';
import { Input, Row, Form, Item, Paragraph, Modal } from 'antd/index';
import messages from 'utils/validationSchemaOptions/validationSchemaOptions';
import CustomSelect from '../CustomSelect/CustomSelect';
import CustomButton from 'components/CustomButton/CustomButton';
import { ADD_NEW_TEST } from '../../constants';

const { subject, title, tooLongText } = messages;
const {
  duplicate,
  testDuplicate,
  addNewTest,
  testName,
  titlePlaceholder,
  categories,
  selectPlaceholder,
  cancel,
  next,
} = ADD_NEW_TEST;
const AddNewTestUI = ({ hideModalTest, handleOnFinish, subjectOptions, isModalVisible, record, form }) => {
  useEffect(() => {
    form.setFieldsValue({
      title: record?.title ? record?.title + duplicate : null,
      subjects: record?.subjects ? [...record?.subjects] : null,
    });
  }, []);
  return (
    <Modal
      footer={null}
      title={record ? testDuplicate : addNewTest}
      visible={isModalVisible}
      onCancel={hideModalTest}
      className="add-test-modal"
      closable={false}
      centered
    >
      <Form
        form={form}
        requiredMark="optional"
        layout="vertical"
        className="container__form form"
        onFinish={handleOnFinish}
        autoComplete="off"
      >
        <Item
          className="form-item form__item"
          label={<Paragraph className="form-item__label">{testName}</Paragraph>}
          rules={[
            {
              whitespace: true,
              required: true,
              message: title,
            },
            {
              max: 100,
              message: tooLongText,
            },
          ]}
          hasFeedback
          id="title"
          name="title"
          tabIndex="0"
        >
          <Input className="form-item__input" placeholder={titlePlaceholder} autoComplete="off" />
        </Item>
        <Item
          className="form__item"
          label={<Paragraph className="form-item__label">{categories}</Paragraph>}
          rules={[
            {
              required: true,
              message: subject,
            },
          ]}
          name="subjects"
        >
          <CustomSelect
            options={subjectOptions}
            placeholder={selectPlaceholder}
            name="subjects"
            tabIndex="1"
            labels={record?.subjects}
          />
        </Item>
        <Row className="action-container" justify="space-around">
          <CustomButton
            onClick={() => {
              hideModalTest(true);
            }}
            className="custom-button--resign"
          >
            {cancel}
          </CustomButton>
          <CustomButton htmlType="submit" className="custom-button--submit">
            {next}
          </CustomButton>
        </Row>
      </Form>
    </Modal>
  );
};
AddNewTestUI.propTypes = {
  hideModalTest: func,
  handleOnFinish: func,
  subjectOptions: array,
  isModalVisible: bool,
  record: object,
  form: oneOfType([func, object]),
};

export default AddNewTestUI;
